import { render, staticRenderFns } from "./WorkSteps.vue?vue&type=template&id=00ff7c9f&scoped=true"
import script from "./WorkSteps.vue?vue&type=script&lang=js"
export * from "./WorkSteps.vue?vue&type=script&lang=js"
import style0 from "./WorkSteps.vue?vue&type=style&index=0&id=00ff7c9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ff7c9f",
  null
  
)

export default component.exports